import type { StateCreator } from 'zustand';
import type { Creature } from '@/domain/creature/types';
import type { AppStore } from './types';

export interface CreatureSliceState {
  creature: Creature | null;
  lightOn: boolean;
  lastFeedAt: number;
  lastPlayAt: number;
  lastMiniGameAt: number;
  discoveredTypes: string[];
}

export interface CreatureSliceActions {
  setActiveCreature: (c: Creature) => void;
  replaceCreature: (c: Creature) => void;
  clearCreature: () => void;
  toggleLight: () => void;
  setLastFeedAt: (t: number) => void;
  setLastPlayAt: (t: number) => void;
  setLastMiniGameAt: (t: number) => void;
  addDiscoveredType: (sig: string) => void;
  setDiscoveredTypes: (list: string[]) => void;
}

export type CreatureSlice = CreatureSliceState & CreatureSliceActions;

export const createCreatureSlice: StateCreator<AppStore, [], [], CreatureSlice> = (set) => ({
  creature: null,
  lightOn: true,
  lastFeedAt: 0,
  lastPlayAt: 0,
  lastMiniGameAt: 0,
  discoveredTypes: [],
  setActiveCreature: (creature) => {
    set({ creature });
  },
  replaceCreature: (creature) => {
    set({ creature });
  },
  clearCreature: () => {
    set({ creature: null });
  },
  toggleLight: () => {
    set((s) => ({ lightOn: !s.lightOn }));
  },
  setLastFeedAt: (lastFeedAt) => {
    set({ lastFeedAt });
  },
  setLastPlayAt: (lastPlayAt) => {
    set({ lastPlayAt });
  },
  setLastMiniGameAt: (lastMiniGameAt) => {
    set({ lastMiniGameAt });
  },
  addDiscoveredType: (sig) => {
    set((s) =>
      s.discoveredTypes.includes(sig) ? s : { discoveredTypes: [...s.discoveredTypes, sig] },
    );
  },
  setDiscoveredTypes: (discoveredTypes) => {
    set({ discoveredTypes });
  },
});
